import React from 'react';

import { CheckListItem } from '../CheckListItem/CheckListItem';
import { Typography } from '../../../components/material-ui/Typography';
import { useStyles } from './useStyles';

export const CheckListContent = React.memo(({ checkListGroups, checkedItems, backgroundColor, toggleCheckItem, isMobile, isTouch }) => {
    const classes = useStyles();

    return Object.values(checkListGroups).reduce((res, checkListGroup, groupIndex) => {
        const { number: groupNumber, name: groupName, hasPerformer, items: groupItems } = checkListGroup;
        if (groupItems && groupItems.length > 0) {
            const items = groupItems.map((item) => (
                <CheckListItem
                    key={`${groupIndex}_${item.templateItemId}`}
                    id={item.templateItemId}
                    item={item}
                    hasPerformer={hasPerformer}
                    checked={checkedItems[item.templateItemId].checked}
                    toggleCheckItem={toggleCheckItem}
                    isMobile={isMobile}
                    isTouch={isTouch}
                />
            ));

            if (items.length > 0) {
                res.push(
                    <section id={groupNumber} key={`${groupIndex}`}>
                        <Typography style={{ backgroundColor }} className={classes.sticky}>
                            <span className={classes.group}>{groupName}</span>
                        </Typography>
                        {items}
                    </section>
                );
            }
        }

        return res;
    }, []);
});
